module.exports = __webpack_public_path__ + "static/img/feixue.98934712.jpg";